import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';

//Components MUi
import {
  Box,
  Collapse,
  Grid,
  IconButton,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
// Additional components
import ArrowDropDownOutlinedIcon from '@mui/icons-material/ArrowDropDownOutlined';
import ArrowDropUpOutlinedIcon from '@mui/icons-material/ArrowDropUpOutlined';
import { LetsGoBtn } from '../../../components/Buttons';
import ApiService from '../../../helpers/apiHelper';
import { dateFormattingByDateShort } from '../../../helpers/date-helpers';
import { StatusHandler } from '../handlers';
import { Spinner } from '../../../components/Spinner';
import { StyledTitle } from '../../../components/StyledComponents';
import { useSnackbar } from 'notistack';
import { setIsOpenParcelDoneModal } from '../../../redux/mainReducer';

function createTableData(
  service,
  seller,
  price,
  buyingDate,
  qty,
  status,
  details,
  estimatedDateShipment,
  serviceID,
  currency,
  orderId
) {
  return {
    service,
    seller,
    price,
    buyingDate,
    qty,
    status,
    details,
    estimatedDateShipment,
    serviceID,
    currency,
    orderId
  };
}

function Row(props) {
  const { row, language, userData } = props;
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const apiChats = new ApiService('notification/chats');
  const apiChangeOrderStatus = new ApiService('posts/order/change-status');
  // const apiChangeOrderStatus = new ApiService('/order/change-status');
  const handleChangeStatus = (status) => {
    apiChangeOrderStatus
      .updateDataQueryPost({ orderId: row.orderId, orderStatus: status })
      .then((res) => {
        props.tableRefresh();
      })
      .catch((error) => {
        console.error(error);
        enqueueSnackbar('Сталася помилка!', { variant: 'error' });
      });
  };

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell component="th" scope="row" sx={{ borderColor: '#F5F4F4', p: '5px 16px' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography
              onClick={() => navigate(`/${language}/service/${row.serviceID}`)}
              sx={{
                fontFamily: 'FixelText-Medium',
                fontSize: { xs: '14px', sm: '16px' },
                cursor: 'pointer',
                width: 'fit-content'
              }}
            >
              {row.service}
            </Typography>
            {row?.details && (
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography
                  sx={{
                    fontFamily: 'FixelText-Medium',
                    color: '#60A5DF',
                    fontSize: { xs: '14px', sm: '16px' },
                    cursor: 'pointer',
                    width: 'max-content'
                  }}
                  onClick={() => setOpen(!open)}
                >
                  {open ? 'Згорнути деталі' : 'Деталі замовлення'}
                </Typography>
                <IconButton
                  disableRipple
                  disableFocusRipple
                  aria-label="expand row"
                  size="small"
                  sx={{
                    color: '#60A5DF',
                    ':hover': {
                      backgroundColor: 'unset !important'
                    }
                  }}
                  onClick={() => setOpen(!open)}
                >
                  {open ? <ArrowDropUpOutlinedIcon /> : <ArrowDropDownOutlinedIcon />}
                </IconButton>
              </Box>
            )}
          </Box>
        </TableCell>
        <TableCell
          align="left"
          sx={{ display: { xs: 'none', md: 'table-cell' }, borderColor: '#F5F4F4', p: '5px 16px' }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography
              variant="subtitle"
              sx={{
                fontFamily: 'FixelText-Regular !important',
                fontSize: { xs: '14px', sm: '16px' },
                textAlign: 'left',
                cursor: 'pointer',
                color: '#60A5DF'
              }}
              onClick={() => {
                navigate(`/${language}/user-page/${row.seller.id}?type=posts`);
              }}
            >
              {`@${row.seller?.nickname}`}
            </Typography>
          </Box>
        </TableCell>
        <TableCell
          align="left"
          sx={{ width: '100px !important', borderColor: '#F5F4F4', p: '5px 16px' }}
        >
          <Typography sx={{ fontSize: { xs: '14px', sm: '16px' } }}>{`${
            row?.price ? row?.price : ''
          } ${row?.currency ? row?.currency : ''}`}</Typography>
        </TableCell>
        {/* <TableCell align="center" sx={{ borderColor: '#F5F4F4', p: '5px 16px' }}>
          <Typography sx={{ fontSize: '16px' }}>{row.buyingDate}</Typography>
        </TableCell> */}
        <TableCell align="left" sx={{ borderColor: '#F5F4F4', p: '5px 16px' }}>
          <Typography sx={{ fontSize: { xs: '14px', sm: '16px' } }}>{row.qty}</Typography>
        </TableCell>
        <TableCell align="center" sx={{ borderColor: '#F5F4F4', p: '5px 16px' }}>
          {StatusHandler(row.status, 'history')}
          {row?.status === 'SENT' && (
            <Typography
              sx={{
                color: '#60A5DF',
                cursor: 'pointer',
                fontSize: { xs: '12px !important', sm: '14px !important', md: '16px !important' },
                ':hover': {
                  scale: '1.05'
                }
              }}
              onClick={() =>
                dispatch(
                  setIsOpenParcelDoneModal({
                    isOpen: true,
                    serviceName: row?.service,
                    seller: row.seller?.nickname,
                    func: handleChangeStatus
                  })
                )
              }
            >
              Вже отримали?
            </Typography>
          )}
        </TableCell>

        <TableCell
          align="left"
          sx={{
            display: { xs: 'none', sm: 'table-cell' },
            borderColor: '#F5F4F4',
            p: '5px 16px',
            fontSize: { xs: '14px', sm: '16px' }
          }}
        >
          {row?.estimatedDateShipment && row?.estimatedDateShipment.length !== 0
            ? row?.estimatedDateShipment
            : '---'}
        </TableCell>
      </TableRow>

      <TableRow>
        {' '}
        {row?.details && (
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Grid
                container
                sx={{ display: 'flex', flexDirection: { xs: 'column-reverse', sm: 'row' } }}
              >
                <Grid
                  item
                  xs={12}
                  sm={6}
                  sx={{
                    width: { xs: '280px', sm: '240px', md: '360px' },
                    maxWidth: { xs: '280px', sm: '240px', md: '360px' },
                    minWidth: { xs: '280px', sm: '240px', md: '360px' },
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'start'
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: 'FixelText-Medium',
                      fontSize: { xs: '12px', sm: '14px' },
                      fontWeight: '600'
                    }}
                  >
                    Дата замовлення:
                  </Typography>
                  <Typography sx={{ fontSize: { xs: '12px', sm: '14px' } }}>
                    {row.buyingDate}
                  </Typography>

                  {row.details.comment.length !== 0 && (
                    <>
                      <Typography
                        sx={{
                          fontFamily: 'FixelText-Medium',
                          fontSize: { xs: '12px', sm: '14px' },
                          fontWeight: '500'
                        }}
                      >
                        Коментар до замовлення:
                      </Typography>
                      <Typography sx={{ fontSize: { xs: '12px', sm: '14px' } }}>
                        {row.details.comment}
                      </Typography>
                    </>
                  )}
                  {row.status === 'DONE' && (
                    <LetsGoBtn
                      lineHeight={{ xs: '14px', sm: '20px' }}
                      colorScheme="white"
                      margin="10px 0px"
                      width={{ xs: '160px', sm: '210px' }}
                      text="Написати відгук"
                      onClick={() => navigate(`/${language}/service/${row.serviceID}`)}
                    >
                      {/*<StarOutlineOutlinedIcon sx={{ color: '#60A5DF', mr: 0.4 }} />*/}
                    </LetsGoBtn>
                  )}
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  sx={{
                    width: { xs: '300px', sm: 'unset', md: 'unset' },
                    maxWidth: { xs: '300px', sm: 'unset', md: 'unset' },
                    minWidth: { xs: '300px', sm: 'unset', md: 'unset' },
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'start',
                    justifyContent: 'start',
                    mb: 2,
                    pl: { xs: 0, sm: 0 }
                  }}
                >
                  <Typography
                    sx={{
                      display: { xs: 'block', md: 'none' },
                      fontFamily: 'FixelText-Medium',
                      fontSize: { xs: '12px', sm: '14px' },
                      fontWeight: '600'
                    }}
                  >
                    Продавець:
                  </Typography>

                  <Typography
                    sx={{
                      display: { xs: 'block', md: 'none' },
                      fontFamily: 'Public Sans,sans-serif !important',
                      fontSize: { xs: '12px', sm: '14px' },
                      textAlign: 'left',
                      cursor: 'pointer',
                      color: '#60A5DF'
                    }}
                    onClick={() => {
                      navigate(`/${language}/user-page/${row.seller.id}?type=posts`);
                    }}
                  >
                    {`@${row.seller?.nickname}`}
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: 'FixelText-Medium',
                      fontSize: { xs: '12px', sm: '14px' },
                      fontWeight: '600'
                    }}
                  >
                    Контактні дані:
                  </Typography>
                  <Typography sx={{ fontSize: { xs: '12px', sm: '14px' } }}>
                    {row.details.contacts}
                  </Typography>
                  <Typography
                    sx={{
                      display: { xs: 'block', md: 'none' },
                      fontFamily: 'FixelText-Medium',
                      fontSize: { xs: '12px', sm: '14px' },
                      fontWeight: '600'
                    }}
                  >
                    Орієнтовна дата відправки:
                  </Typography>
                  <Typography
                    sx={{
                      display: { xs: 'block', md: 'none' },
                      fontSize: { xs: '12px', sm: '14px' }
                    }}
                  >
                    {row?.estimatedDateShipment && row?.estimatedDateShipment.length !== 0
                      ? row?.estimatedDateShipment
                      : '---'}
                  </Typography>

                  <Typography
                    sx={{
                      fontFamily: 'FixelText-Medium',
                      fontSize: { xs: '12px', sm: '14px' },
                      fontWeight: '600'
                    }}
                  >
                    Спосіб доставки:
                  </Typography>
                  <Typography sx={{ fontSize: { xs: '12px', sm: '14px' } }}>
                    {row.details.deliveryType}
                  </Typography>
                  <LetsGoBtn
                    colorScheme="blue"
                    lineHeight={{ xs: '14px', sm: '20px' }}
                    margin="10px 0px 0px"
                    width={{ xs: '160px', sm: '210px' }}
                    onClick={() => {
                      apiChats
                        .postDataQuery({
                          userId: userData.id,
                          recipientId: row.seller.id
                        })
                        .then((res) => {
                          navigate(`/${language}/messages`);
                        })
                        .catch((error) => {
                          if (error?.message.includes('There is a chat between these users')) {
                            const id = `${error.message.slice(
                              error.message.indexOf('[') + 1,
                              error.message.length - 1
                            )}`;

                            navigate(`/${language}/messages?chatId=${id}`);
                          }
                        });
                    }}
                    text="Написати продавцю"
                  />
                </Grid>
              </Grid>
            </Collapse>
          </TableCell>
        )}
      </TableRow>
    </React.Fragment>
  );
}

function History({ language, data, userData, blockedUsers, ...props }) {
  const apiHistoryOrders = new ApiService('posts/scheduler/history');

  // const apiHistoryOrders = new ApiService('/scheduler/history');
  // eslint-disable-next-line
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoadiang] = useState(false);
  const [from, setFrom] = useState(0);
  const [pages, setPages] = useState(0);
  const [selectedPage, setSelectedPage] = useState(1);
  // eslint-disable-next-line
  const [params, setParams] = useSearchParams();

  const dataSetter = () => {
    setIsLoadiang(true);
    apiHistoryOrders
      .getAll({
        from: 0,
        size: 5,
        search: params.get('question') ? params.get('question') : '',
        sortDirection: params.get('sd') ? params.get('sd') : 'DESC'
      })
      .then((res) => {
        const preparedRows = res.result.map((order) =>
          createTableData(
            order?.service?.nameService,
            order?.seller,
            +order?.price,
            dateFormattingByDateShort(new Date(order?.buyingDate)),
            `${order?.qty} од.`,
            order?.status,
            {
              about: order?.service?.nameService,
              contacts: order?.details?.contact,
              deliveryType: order?.details?.deliveryType,
              paymentType: order?.details?.paymentType,
              comment: order?.details?.comment
            },
            order?.estimatedTimeShipment !== null && order?.estimatedTimeShipment
              ? dateFormattingByDateShort(new Date(order?.estimatedTimeShipment))
              : null,
            order?.service?.id,
            order?.currency,
            order?.id
          )
        );
        setRows(preparedRows);
        setIsLoadiang(false);
        const countPages = Number.isInteger(res.count / 5)
          ? res.count / 5
          : Math.floor(res.count / 5) + 1;

        setPages(countPages);
      })
      .catch((error) => {
        setIsLoadiang(false);
        console.error(error);
      });
  };
  const handleChangePage = (page) => {
    apiHistoryOrders
      .getAll({
        from: 5 * (page - 1),
        size: 5,
        search: params.get('question') ? params.get('question') : '',
        sortDirection: params.get('sd') ? params.get('sd') : 'DESC'
      })
      .then((res) => {
        const preparedRows = res.result.map((order) =>
          createTableData(
            order?.service?.nameService,
            order?.seller,
            +order?.price,
            dateFormattingByDateShort(new Date(order?.buyingDate)),
            `${order?.qty} ${order?.service?.initOfMeasure}.`,
            order?.status,
            {
              about: order?.service?.nameService,
              contacts: order?.details?.contact,
              deliveryType: order?.details?.deliveryType,
              paymentType: order?.details?.paymentType,
              comment: order?.details?.comment
            },
            order?.estimatedTimeShipment !== null && order?.estimatedTimeShipment
              ? dateFormattingByDateShort(new Date(order?.estimatedTimeShipment))
              : null,
            order?.service?.id,
            order?.currency,
            order?.id
          )
        );
        setRows(preparedRows);
        setIsLoadiang(false);
        setFrom(5 * (page - 1));
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const tableRefresh = () => {
    setIsLoadiang(true);
    apiHistoryOrders
      .getAll({
        from: from,
        size: 5,
        search: params.get('question') ? params.get('question') : '',
        sortDirection: params.get('sd') ? params.get('sd') : 'DESC'
      })
      .then((res) => {
        const preparedRows = res.result.map((order) =>
          createTableData(
            order?.service?.nameService,
            order?.seller,
            +order?.price,
            dateFormattingByDateShort(new Date(order?.buyingDate)),
            `${order?.qty} од.`,
            order?.status,
            {
              about: order?.service?.nameService,
              contacts: order?.details?.contact,
              deliveryType: order?.details?.deliveryType,
              paymentType: order?.details?.paymentType,
              comment: order?.details?.comment
            },
            order?.estimatedTimeShipment !== null && order?.estimatedTimeShipment
              ? dateFormattingByDateShort(new Date(order?.estimatedTimeShipment))
              : null,
            order?.service?.id,
            order?.currency,
            order?.id
          )
        );
        setRows(preparedRows);
        setIsLoadiang(false);
        
      })
      .catch((error) => {
        setIsLoadiang(false);
        console.error(error);
      });
  };
  useEffect(() => {
    dataSetter();
    return () => {
      setFrom(0);
    };
    // eslint-disable-next-line
  }, []);
  return (
    <>
      <TableContainer
        component={Paper}
        sx={
          rows.length !== 0
            ? {
                borderRadius: '5px 5px 0px 0px !important',
                mt: 2.4,
                border: '2px solid #F5F4F4',
                borderBottom: 'none !important'
              }
            : {
                borderRadius: '5px 5px 0px 0px !important',
                mt: 2.4,
                backgroundColor: 'transparent !important',
                border: '2px solid #F5F4F4',
                borderBottom: 'none !important'
              }
        }
      >
        <Table aria-label="collapsible table">
          <TableHead sx={{ background: '#E2F2FF' }}>
            <TableRow>
              <TableCell
                align="left"
                sx={{
                  width: { xs: '150px', sm: '200px', md: '300px' },
                  maxWidth: { xs: '150px', sm: '200px', md: '300px' },
                  minWidth: { xs: '150px', sm: '200px', md: '300px' },
                  fontFamily: 'FixelText-Medium',
                  fontSize: { xs: '14px', sm: '16px' },
                  borderColor: '#F5F4F4',
                  padding: '10px',
                  lineHeight: { xs: '24px', sm: '34px' }
                }}
              >
                Товар
              </TableCell>
              <TableCell
                align="left"
                sx={{
                  display: { xs: 'none', md: 'table-cell' },
                  width: '220px',
                  maxWidth: '220px',
                  minWidth: '220px',
                  fontFamily: 'FixelText-Medium',
                  fontSize: { xs: '14px', sm: '16px' },
                  borderColor: '#F5F4F4',
                  padding: '10px',
                  lineHeight: { xs: '24px', sm: '34px' }
                }}
              >
                Продавець
              </TableCell>
              <TableCell
                align="left"
                sx={{
                  width: { xs: '80px', sm: '100px', md: '150px' },
                  maxWidth: { xs: '80px', sm: '100px', md: '150px' },
                  minWidth: { xs: '80px', sm: '100px', md: '150px' },
                  fontFamily: 'FixelText-Medium',
                  fontSize: { xs: '14px', sm: '16px' },
                  borderColor: '#F5F4F4',
                  padding: '10px',
                  lineHeight: { xs: '24px', sm: '34px' }
                }}
              >
                Сума
              </TableCell>
              {/* <TableCell
              align="center"
              sx={{
                fontFamily: 'FixelText-Medium',
                fontSize:{xs:'14px', sm: '16px'},
                borderColor: '#F5F4F4',
                padding: '10px'
              }}
            >
              Дата замовлення
            </TableCell> */}
              <TableCell
                align="left"
                sx={{
                  width: { xs: '80px', sm: '100px' },
                  maxWidth: { xs: '80px', sm: '100px' },
                  minWidth: { xs: '80px', sm: '100px' },
                  fontFamily: 'FixelText-Medium',
                  fontSize: { xs: '14px', sm: '16px' },
                  borderColor: '#F5F4F4',
                  padding: '10px',
                  lineHeight: { xs: '24px', sm: '34px' }
                }}
              >
                Кількість
              </TableCell>
              <TableCell
                align="left"
                sx={{
                  width: { xs: '90px', sm: '100px', md: '115px' },
                  maxWidth: { xs: '90px', sm: '100px', md: '115px' },
                  minWidth: { xs: '90px', sm: '100px', md: '115px' },
                  fontFamily: 'FixelText-Medium',
                  fontSize: { xs: '14px', sm: '16px' },
                  borderColor: '#F5F4F4',
                  padding: '10px',
                  lineHeight: { xs: '24px', sm: '34px' }
                }}
              >
                Статус
              </TableCell>
              <TableCell
                align="left"
                sx={{
                  width: { xs: '80px', sm: '100px' },
                  maxWidth: { xs: '80px', sm: '100px' },
                  minWidth: { xs: '80px', sm: '100px' },
                  display: { xs: 'none', sm: 'table-cell' },
                  fontFamily: 'FixelText-Medium',
                  fontSize: { xs: '14px', sm: '16px' },
                  borderColor: '#F5F4F4',
                  padding: '10px',
                  lineHeight: { xs: '24px', sm: '34px' }
                }}
              >
                Відправка
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!isLoading ? (
              <>
                {rows.length !== 0 ? (
                  rows.map((row, index) => (
                    <Row
                      key={`${row.service + index}`}
                      row={row}
                      language={language}
                      userData={userData}
                      blockedUsers={blockedUsers}
                      tableRefresh={tableRefresh}
                    />
                  ))
                ) : (
                  <TableCell
                    style={{ paddingBottom: 200, paddingTop: 200 }}
                    sx={{ backgroundColor: 'transparent', borderBottom: 'none' }}
                    colSpan={7}
                  >
                    <Grid
                      container
                      sx={{
                        maxWidth: '100%'
                        // mt: '20% !important'
                      }}
                      spacing={3}
                    >
                      <Grid item xs={12} sx={{ paddingBottom: '0px' }}>
                        <StyledTitle
                          maxWidth={800}
                          sx={{
                            lineHeight: '38px !important',
                            fontSize: '32px !important',
                            textTransform: 'initial !important',
                            margin: '0px auto 20px !important'
                          }}
                          className="bottomBlock-title"
                        >
                          Тут порожньо
                        </StyledTitle>
                      </Grid>
                      <Grid item xs={12} sx={{ mt: 0, display: 'flex', justifyContent: 'center' }}>
                        <Typography textAlign="center" sx={{ maxWidth: '640px' }}>
                          Поки що у вас не було покупок.
                        </Typography>
                      </Grid>
                    </Grid>
                  </TableCell>
                )}
              </>
            ) : (
              <TableCell style={{ paddingBottom: 200, paddingTop: 200 }} colSpan={7}>
                <Spinner />
              </TableCell>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {rows.length !== 0 && !isLoading && (
        <Pagination
          sx={{
            mt: 0,
            mb: 0,
            p: '8px',
            borderTop: 'none',
            border: '2px solid #F5F4F4',
            backgroundColor: 'white',
            borderRadius: '0px 0px 5px 5px',
            display: 'flex',
            justifyContent: 'end',
            '& ul > li > button:not(.Mui-selected)': {
              backgroundColor: 'transparent',
              color: 'gray',
              borderColor: `gray!important`,
              margin: 1
            },
            '& .MuiPaginationItem-root': {
              color: 'gray',
              fontSize: '18px'
            },
            '& .Mui-selected': {
              backgroundColor: 'transparent',
              color: '#60A5DF',
              borderColor: '#60A5DF'
            }
          }}
          count={pages}
          defaultPage={1}
          siblingCount={2}
          variant="outlined"
          shape="rounded"
          onChange={(event, value) => {
            if (selectedPage !== +value) {
              setSelectedPage(+value);
              handleChangePage(value);
            } else {
              return;
            }
          }}
        />
      )}
    </>
  );
}
const mapStateToProps = (state) => {
  return {
    language: state.Intl.locale,
    userData: state.global.userData,
    blockedUsers: state.global.blockedUsers
  };
};

export default connect(mapStateToProps)(History);
